var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loggedIn && _vm.numberOfItemsInShoppingCart)?_c('span',{staticClass:"c-shopping-cart-button__amount"},[_vm._v("\n  "+_vm._s(_vm.numberOfItemsInShoppingCart)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }